import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';
import { RuntimeEnvironment } from '@/environment/runtime-environment';

const googleApiKeyMap = {
  [RuntimeEnvironment.LOCAL]: 'AIzaSyBZoGIm5quQz0FlDEoMNN5T-bjgsFWg6YI',
  [RuntimeEnvironment.PRD]: 'AIzaSyADKhkw892l4MRW_w-DnnsH5AxQFbQAMgQ',
  [RuntimeEnvironment.TEST]: 'AIzaSyAL7dMF1QRJw8gd4-k-G4W1_PdO0a1xTAs',
  [RuntimeEnvironment.HML]: 'AIzaSyDPyq3FnH1YB5o5d-Fp53BjHiKxc47zWvw',
};

export const getGoogleKeyApi = () => {
  const isClient = typeof window !== 'undefined';

  const runtimeEnv = isClient
    ? getRuntimeEnvironment(window.location.origin || '')
    : RuntimeEnvironment.LOCAL;

  return googleApiKeyMap[runtimeEnv];
};
